export default "__VITE_ASSET__DTbwKb_d__"